var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoconference(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512.196 512.196",
    height: 512,
    viewBox: "0 0 512.196 512.196",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m463.177 392.818h-414.157c-18.789 0-34.02-15.231-34.02-34.02v-309.19c0-18.789 15.231-34.02 34.02-34.02h414.157c18.789 0 34.02 15.231 34.02 34.02v309.19c0 18.788-15.232 34.02-34.02 34.02z",
    fill: "#cef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m463.177 15.588h-207.133v377.23h207.133c18.789 0 34.02-15.231 34.02-34.02v-309.19c0-18.789-15.232-34.02-34.02-34.02z",
    fill: "#ff405c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 204.203v154.595c0 18.789 15.231 34.02 34.02 34.02h414.156c18.789 0 34.02-15.231 34.02-34.02v-154.595z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.044 204.203v188.615h207.133c18.789 0 34.02-15.231 34.02-34.02v-154.595z",
    fill: "#00215a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.041 496.694 16.31-103.876h132.903l14.638 103.864z",
    fill: "#004db6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.044 496.694 80.848-.006-14.638-103.864h-66.21z",
    fill: "#192b80"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m374.747 511.608h-237.298c-8.284 0-15-6.716-15-15s6.716-15 15-15h237.298c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
    fill: "#0089ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m374.747 481.608h-118.703v30h118.703c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#295fcc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.119,
    cy: 286.65,
    fill: "#ffa64d",
    r: 34.631
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.119 252.019v69.262c19.126 0 34.631-15.505 34.631-34.631s-15.505-34.631-34.631-34.631z",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.598 326.637h-45.439l-.002.007c-19.182.151-34.686 15.741-34.686 34.959v7.85c0 5.057 4.099 9.156 9.156 9.156h96.781c5.057 0 9.156-4.099 9.156-9.156v-7.85c0-19.311-15.655-34.966-34.966-34.966z",
    fill: "#7affe4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.598 326.637h-22.48v51.972h48.29c5.057 0 9.156-4.099 9.156-9.156v-7.85c0-19.311-15.655-34.966-34.966-34.966z",
    fill: "#00ecce"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.695,
    cy: 286.65,
    fill: "#fc9",
    r: 34.631
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.695 252.019v69.262c19.126 0 34.631-15.505 34.631-34.631s-15.505-34.631-34.631-34.631z",
    fill: "#ffb366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.174 326.637h-45.439l-.002.007c-19.182.151-34.686 15.741-34.686 34.959v7.85c0 5.057 4.099 9.156 9.156 9.156h96.781c5.057 0 9.156-4.099 9.156-9.156v-7.85c0-19.311-15.655-34.966-34.966-34.966z",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.174 326.637h-22.48v51.972h48.29c5.057 0 9.156-4.099 9.156-9.156v-7.85c0-19.311-15.655-34.966-34.966-34.966z",
    fill: "#ff641a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.119,
    cy: 112.23,
    fill: "#ffa64d",
    r: 34.631
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.119 77.599v69.262c19.126 0 34.631-15.505 34.631-34.631s-15.505-34.631-34.631-34.631z",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.598 152.217h-45.439l-.002.007c-19.182.151-34.686 15.741-34.686 34.959v7.85c0 5.057 4.099 9.156 9.156 9.156h96.781c5.057 0 9.156-4.099 9.156-9.156v-7.85c0-19.311-15.655-34.966-34.966-34.966z",
    fill: "#ffda2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.598 152.217h-22.48v51.972h48.29c5.057 0 9.156-4.099 9.156-9.156v-7.85c0-19.311-15.655-34.966-34.966-34.966z",
    fill: "#fdbf00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.695,
    cy: 112.23,
    fill: "#fc9",
    r: 34.631
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.695 77.599v69.262c19.126 0 34.631-15.505 34.631-34.631s-15.505-34.631-34.631-34.631z",
    fill: "#ffb366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.174 152.217h-45.439l-.002.007c-19.182.151-34.686 15.741-34.686 34.959v7.85c0 5.057 4.099 9.156 9.156 9.156h96.781c5.057 0 9.156-4.099 9.156-9.156v-7.85c0-19.311-15.655-34.966-34.966-34.966z",
    fill: "#ff405c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.174 152.217h-22.48v51.972h48.29c5.057 0 9.156-4.099 9.156-9.156v-7.85c0-19.311-15.655-34.966-34.966-34.966z",
    fill: "#c1126b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467.141 407.818h-422.085c-24.884 0-45.056-20.172-45.056-45.056v-317.119c0-24.883 20.172-45.055 45.056-45.055h422.086c24.883 0 45.055 20.172 45.055 45.055v317.12c-.001 24.883-20.173 45.055-45.056 45.055zm-422.085-377.23c-8.315 0-15.056 6.74-15.056 15.055v317.119c0 8.315 6.741 15.056 15.056 15.056h422.085c8.315 0 15.056-6.741 15.056-15.056v-317.119c0-8.315-6.741-15.056-15.056-15.056h-422.085z",
    fill: "#0089ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m470.919.588h-214.875v30h214.875c6.228 0 11.277 5.049 11.277 11.277v319.954c0 8.836-7.163 15.999-15.999 15.999h-210.153v30h214.875c22.797 0 41.277-18.48 41.277-41.277v-324.676c0-22.797-18.48-41.277-41.277-41.277z",
    fill: "#295fcc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoconference);
export default __webpack_public_path__ + "static/media/videoconference.4e2f1c07be00fef333b91ae5d050f25b.svg";
export { ForwardRef as ReactComponent };